<template lang="pug">
  .modal
    .modal__wrap(@click.self="overlayClick")
      .modal__window(:class="size")
        slot(name="header")
          .modal__header
              label.title.ellipsis {{title}}
              a.close(@click="$emit('close')") &times;
        .modal__content
          slot
        .modal__footer
          slot(name="footer")
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: 'md',
    },
    closeWithOverlay: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Title',
    },
  },
  created () {
    document.body.style.overflowY = 'hidden'
  },
  destroyed () {
    document.body.style.overflowY = 'scroll'
  },
  methods: {
    overlayClick () {
      if (this.closeWithOverlay) this.$emit('close')
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .modal
    position fixed
    z-index 101
    top 0
    left 0
    width 100vw
    height 100vh
    overflow hidden
    background-color $default-color-bold-opacity
    &__wrap
      width calc(100vw + 16px)
      padding-right 16px
      height 100vh
      overflow-x hidden
      display flex
      justify-content center
    &__window
      display block
      height fit-content
      padding 50px 0
      &.xs
        width 35vw
      &.sm
        width 50vw
      &.md
        width 75vw
      &.lg
        width 90vw

    &__header
      width 100%
      background-color $cyprus-color
      display flex
      align-items center
      justify-content space-between
      position relative
      color $white-color
      font-size 125%
      height 75px
      padding 15px 5%
      .title
        font-weight 600
        padding-right 15px
      .close
        font-size 175%
        font-weight 500
        &:hover
          color $danger-color
    &__content
      width 100%
      background-color $white-color
      display flex
      flex-direction column
      align-items center
      padding 25px 0
      .container
        width 90%
        min-width auto
    &__footer
      display flex
      background-color $white-color
      padding 0 5% 25px
      .container
        width 100%
        margin-bottom 15px
        min-width auto

  @media (max-width: $laptop)
    .modal
      &__header
        padding 15px 20px
      &__footer
        padding 0 20px 25px
      &__content
        padding 15px 0
        .container
          width 100%
      &__window
        &.xs
          width 50%
        &.sm
          width 75%
        &.md
          width 95%
        &.lg
          width 95%
  @media (max-width: $tablet)
    .modal
      &__window
        &.xs, &.sm, &.md, &.lg
          width 95%
</style>



// WEBPACK FOOTER //
// src/components/lei-components/LeiModal.vue